import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { adminLogin } from "../../api";
import { Loader2, LogIn } from "lucide-react";
import SEO from "../../components/SEO";

export default function AdminLogin() {
  const nav = useNavigate();
  const [form, setForm] = useState({ username: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const r = await adminLogin(form.username, form.password);
      localStorage.setItem("revive_admin_token", r.token);
      localStorage.setItem("revive_admin_user", r.username);
      nav("/admin");
    } catch (e) {
      setError(e?.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-neutral-50 p-6">
      <SEO title="Admin Login | Revive Solutions" description="Admin login" />
      <div className="w-full max-w-md bg-white border border-neutral-200 rounded-lg p-8 shadow-sm">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-11 h-11 bg-[#e30613] text-white grid place-items-center font-bold text-xl rounded-md">R</div>
          <div><div className="font-display text-lg font-semibold">Revive Solutions</div><div className="text-xs text-slate-500 uppercase tracking-wider">Admin Panel</div></div>
        </div>
        <h1 className="font-display text-2xl mb-2">Sign in</h1>
        <p className="text-sm text-slate-500 mb-6">Enter your credentials to access the CRM.</p>
        <form onSubmit={submit} className="space-y-4">
          <div><label className="field-label">Username</label><input value={form.username} onChange={(e) => setForm({ ...form, username: e.target.value })} className="field" placeholder="admin username" autoComplete="username" /></div>
          <div><label className="field-label">Password</label><input type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="field" placeholder="••••••••" autoComplete="current-password" /></div>
          {error && <div className="text-sm text-[#e30613]">{error}</div>}
          <button type="submit" disabled={loading} className="btn-primary w-full justify-center">{loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <><LogIn className="w-4 h-4" /> Sign in</>}</button>
        </form>
        <div className="text-center mt-6"><Link to="/" className="text-sm text-slate-500 hover:text-[#e30613]">← Back to website</Link></div>
      </div>
    </div>
  );
}
